export default "__VITE_ASSET__CsYVQjth__"